import { Button } from "@mui/material";
import "./popMenu.scss";
const PpmPop = ({ setppmPop }: any) => {
  return (
    <>
      <div  onClick={()=>{
         setppmPop(false)
      }} className="business-summary-popUp">
        <div className="business-summary-main-dev ppm-dev">
          <samp>
            <img src="https://public.ticca.com/images/svg/ReQuest_Sent.svg" />
          </samp>
          <p style={{ color: "white" }}>
            Thank you for your request.
            <br />
            Our Founder will review and contact you as soon as possible.
          </p>

          <samp
            onClick={() => {
              setppmPop(false);
            }}
            className="investor-close"
          >
           <img src="https://public.ticca.com/images/svg/InvestorMenuCloseArrow.svg" alt="close-icon" />
          </samp>
        </div>
      </div>
    </>
  );
};

export default PpmPop;
